module.exports = __webpack_public_path__ + "img/toblingerknoten.271ee399.jpg";